import Rest from '@services/Rest'

/**
 * @typedef {RefundGroupService}
 */
export default class RefundGroupService extends Rest {
  /**
   * @type {String}
   */
  // '/erp/refund-solicitation' -- ainda nao subiu o back
  static resource = 'refund-solicitation/group'
}
